// extracted by mini-css-extract-plugin
module.exports = {"postCard":"PostCard_postCard__uZIlT"};